export declare const server: (serv: Server) => void;
export declare const player: (player: Player, serv: Server) => void;
declare global {
    interface Server {
        /** Broadcasts `message` to all the players with the optional `color`. */
        "broadcast": (message: any, opt?: {
            whitelist?: any;
            blacklist?: any[];
            system?: boolean;
        }) => void;
    }
    interface Player {
        /** sends `message` to the player */
        "chat": (message: any) => void;
    }
}
